import { useCallback } from 'react';
import { useNavigation } from '@react-navigation/native';

import { useTelemetry } from '@order/Telemetry';

import { useNavigateToMainTabs } from '../../../../navigation';

export const useHomeNavigation = (orderId: string | null = null) => {
  const { track } = useTelemetry();
  const navigation = useNavigation();

  // ─── Navigation ──────────────────────────────────────────────────────

  const navigateToMainTabs = useNavigateToMainTabs(navigation);

  const navigateToAccount = useCallback(() => {
    track('home.account.cta_tapped');
    void navigateToMainTabs('AccountTab', { screen: 'AccountMenu' });
  }, [navigateToMainTabs, track]);

  const navigateToLoyalty = useCallback(() => {
    track('home.loyalty.cta_tapped');
    void navigateToMainTabs('LoyaltyTab', { screen: 'LoyaltyHome' });
  }, [navigateToMainTabs, track]);

  const navigateToSignIn = useCallback(() => {
    track('home.banner.cta_tapped', { destination: 'SignIn' });
    navigation.navigate('Auth', {
      screen: 'JoinOrSignIn',
      params: { redirect: 'home' },
    });
  }, [navigation, track]);

  const navigateToOrderStatus = useCallback(() => {
    if (!orderId) return;

    track('home.banner.cta_tapped', { destination: 'OrderStatus' });
    navigation.navigate('Modal', {
      screen: 'OrderStatus',
      params: { orderId },
    });
  }, [navigation, orderId, track]);

  const navigateToRateOrder = useCallback(() => {
    if (!orderId) return;

    track('home.banner.cta_tapped', { destination: 'RateOrder' });
    navigation.navigate('Modal', {
      screen: 'RateOrder',
      params: { orderId },
    });
  }, [navigation, orderId, track]);

  return {
    navigateToAccount,
    navigateToLoyalty,
    navigateToSignIn,
    navigateToOrderStatus,
    navigateToRateOrder,
  };
};
